import { getLogger } from '@/logger/logger';

const logger = getLogger('feature-flags');

export interface FeatureFlagLogMeta {
  flagKey?: string;
  userId?: string;
  enabled?: boolean;
  variant?: string | null;
  isFallback?: boolean;
  durationMs?: number;
  reason?: string;
  error?: unknown;
  [key: string]: unknown;
}

export function logEvaluation(
  flagKey: string,
  result: { enabled?: boolean; variant?: string | null; isFallback: boolean },
  context?: { userId?: string; durationMs?: number; variant?: string | null },
) {
  const meta: FeatureFlagLogMeta = {
    flagKey,
    enabled: result.enabled,
    variant: result.variant ?? context?.variant,
    isFallback: result.isFallback,
    userId: context?.userId,
    durationMs: context?.durationMs,
  };

  if (result.isFallback) {
    logger.warn('Feature flag evaluated with fallback', meta);
  } else {
    logger.debug('Feature flag evaluated', meta);
  }
}

export function logError(
  message: string,
  error: unknown,
  meta?: FeatureFlagLogMeta,
) {
  logger.error(message, meta, error);
}

export function logInfo(message: string, meta?: FeatureFlagLogMeta) {
  logger.info(message, meta);
}

export function logWarning(message: string, meta?: FeatureFlagLogMeta) {
  logger.warn(message, meta);
}

export function logDebug(message: string, meta?: FeatureFlagLogMeta) {
  logger.debug(message, meta);
}
